import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NotificationModel} from '../../../model/user/NotificationModel';
import * as urlRegex from 'url-regex';

@Component({
  selector: 'app-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.css']
})
export class InfoDialogComponent implements OnInit {

  body: string;
  title = '';
  choose = 'Rimuovi';

  constructor(public dialogRef: MatDialogRef<InfoDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: NotificationModel) {
    // tslint:disable-next-line:only-arrow-functions
  }

  ngOnInit(): void {
    // tslint:disable-next-line:only-arrow-functions
    this.body = this.data.body.replace(urlRegex({strict: false}), function(url) {
      return '<a href="' + url + '">' + 'link' + '</a>';
    });
    const arr = this.data.title.split(' ').slice(2, this.data.title.length);
    arr.forEach(e => this.title += e + ' ');
  }

}
